export default "__VITE_ASSET__BPNci4gC__"